import { useNavigation, usePreventRemove } from "@react-navigation/native";
import * as React from "react";
function useBlocker(shouldBlock) {
  var navigation = useNavigation();
  var [state, setState] = React.useState("unblocked");
  var [pendingAction, setPendingAction] = React.useState(null);
  var [blockedLocation, setBlockedLocation] = React.useState(null);
  var block = typeof shouldBlock === "function" ? shouldBlock({
    currentLocation: "",
    nextLocation: "previous screen",
    historyAction: "pop"
  }) : shouldBlock;
  usePreventRemove(block, function(param) {
    var { data } = param;
    var _data_action;
    var payload = data === null || data === void 0 ? void 0 : (_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.payload;
    setPendingAction(data.action);
    setBlockedLocation((payload === null || payload === void 0 ? void 0 : payload.name) || "previous screen");
    setState("blocked");
  });
  var reset = React.useCallback(function() {
    setPendingAction(null);
    setBlockedLocation(null);
    setState("unblocked");
  }, []);
  var proceed = React.useCallback(function() {
    if (!pendingAction) return;
    setState("proceeding");
    navigation.dispatch(pendingAction);
    setTimeout(function() {
      setPendingAction(null);
      setBlockedLocation(null);
      setState("unblocked");
    }, 100);
  }, [
    navigation,
    pendingAction
  ]);
  if (state === "unblocked") {
    return {
      state: "unblocked"
    };
  }
  if (state === "proceeding") {
    return {
      state: "proceeding",
      location: blockedLocation
    };
  }
  return {
    state: "blocked",
    reset,
    proceed,
    location: blockedLocation
  };
}
function checkBlocker(_nextLocation) {
  var _historyAction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "push";
  return false;
}
export {
  checkBlocker,
  useBlocker
};
//# sourceMappingURL=useBlocker.native.js.map
